import { isEmpty, reduce } from 'lodash-es';

import { fetchDataByAsset } from './fetchDataByAsset';
import { aiDashboardAssets } from '../configs/constants';

// Response transformers
const aiMarketOverviewTransformResponse = (data) => {
  if (isEmpty(data)) return { data: {} };

  return {
    data: {
      time_series: {
        growth: data.growth || {},
        indexed: data.indexed?.metrics || {},
        market_share: reduce(
          data.market_share,
          (result, seriesByMetric, appRefNo) => ({
            ...result,
            ...reduce(
              seriesByMetric,
              (acc, series, metric) => ({
                ...acc,
                [metric]: {
                  ...result[metric],
                  [appRefNo]: series,
                },
              }),
              {}
            ),
          }),
          {}
        ),
      },
    },
  };
};

// Request
export const fetchAiMarketOverview = () =>
  fetchDataByAsset(
    aiDashboardAssets.marketOverview,
    {},
    { transformResponse: (data) => aiMarketOverviewTransformResponse(data) }
  );
